import { createContext, useContext, useState, type ReactNode } from 'react'

/**
 * Opt-in services (delivery, assembly) the user can add to the price. State is
 * shared so the toggles (rendered in the controls area) and the displayed total
 * (rendered in the price bar) stay in sync.
 */
interface ServiceOptionsValue {
  delivery: boolean
  assembly: boolean
  setDelivery: (value: boolean) => void
  setAssembly: (value: boolean) => void
}

const noop = () => {}

const ServiceOptionsContext = createContext<ServiceOptionsValue>({
  delivery: false,
  assembly: false,
  setDelivery: noop,
  setAssembly: noop,
})

export function ServiceOptionsProvider({ children }: { children: ReactNode }) {
  const [delivery, setDelivery] = useState(false)
  const [assembly, setAssembly] = useState(false)
  return (
    <ServiceOptionsContext.Provider
      value={{ delivery, assembly, setDelivery, setAssembly }}
    >
      {children}
    </ServiceOptionsContext.Provider>
  )
}

export function useServiceOptions(): ServiceOptionsValue {
  return useContext(ServiceOptionsContext)
}
